import ISecondaryStatus from '@core-shared/interfaces/ISecondaryStatus';

export default class SecondaryStatus implements ISecondaryStatus {
	headcontract: boolean = false;
	budget: boolean = false;
} 